import { IOrderingActivityProps } from "../../properties/ActivityProperties";
import {
  parseBodyMapFromData,
  parseContentMapFromData,
  parseMaterialMapFromData,
} from "../../utilization/CatchtivityUtilization";
import ActivityBodyContent from "./body-contents/ActivityBodyContent";
import OrderingActivityMaterialContent from "./material-contents/OrderingActivityMaterialContent";
import ActivitySolveLayout from "./ActivitySolveLayout";

const OrderingActivityContent = ({
  answerMap,
  data,
  canAnswerQuestion,
  changeAnswer,
  isPreview,
  showCorrectAnswer,
  isFullScreen,
  passage,
}: IOrderingActivityProps) => {
  const contentMap = parseContentMapFromData(data);
  const orderingBodyMap = parseBodyMapFromData(data, "ORDERING");
  const orderingMaterialMap = parseMaterialMapFromData(data, "ORDERING");

  const handleOrderingAnswerOnChange = (
    answerMap: any,
    primaryKey: any,
    secondaryKey: any,
  ) => {
    if (isPreview) return;
    const prevValue = answerMap[primaryKey];
    answerMap[primaryKey] = answerMap[secondaryKey];
    answerMap[secondaryKey] = prevValue;
    changeAnswer(answerMap);
  };

  return (
    <ActivitySolveLayout
      variant="wide"
      isFullScreen={isFullScreen}
      passage={passage}
      body={
        <ActivityBodyContent
          bodyMap={orderingBodyMap}
          templateType={"ORDERING"}
        />
      }
      interaction={
        <OrderingActivityMaterialContent
          uniqueValue={JSON.stringify(data.contentMap)}
          answerMap={answerMap}
          materialMap={orderingMaterialMap}
          contentMap={contentMap}
          checkCanAnswerQuestion={canAnswerQuestion}
          onChange={handleOrderingAnswerOnChange}
          isPreview={isPreview}
          showCorrectAnswer={showCorrectAnswer}
        />
      }
    />
  );
};

export default OrderingActivityContent;
